module.exports = __webpack_public_path__ + "img/double_arrow_white.878562b6.svg";